export default __webpack_public_path__ + "static/media/jym.df6e63c2.jpg";